import { MepTestAcceptabilitySummary, TestResults } from '../../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { ParameterTypeName } from '../ParameterTypes';

export function MapMepTestAcceptabilitySummaries(testResults: TestResults[]): Array<MepTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            Accepted: tr.OverreaderAcceptability,
            TestId: tr.TestId,
            Mep: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_MEP).Value,
            Pep: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_PEP).Value,
        } as MepTestAcceptabilitySummary;
    });
}
